import { useState, useEffect } from 'react';

const imageStyle = (maxWidth) =>  {
  return {
    maxWidth: maxWidth,
    minWidth: '10%',
    border: '4px solid rgba(0,0,0,0.1)',
    borderRadius: 8,
    background: 'white',
    transition: 'transform 0.2s ease-in-out'
}}

export const SpecialImage = (image, maxWidth) => {
  const [isZoomed, setIsZoomed] = useState(false);
  
  const handleClick = e => {
    e.preventDefault();
    if (isZoomed) {
      window.open(image, '_blank');
    } else {
      setIsZoomed(true);
    }
  };

  const handleOverlay = e => e.target.className.includes('overlay') && setIsZoomed(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isZoomed) {
        setIsZoomed(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isZoomed]);

  return (
    <>
      <div style={{ display: 'inline', padding: 5, verticalAlign: 'top' }}>
        <a href={image} onClick={handleClick}>
          <img
            src={image}
            alt="logo"
            style={imageStyle(maxWidth)}
            onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
          />
        </a>
      </div>

      {isZoomed && (
        <div
          className="overlay"
          onClick={handleOverlay}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 50,
            opacity: 0,
            animation: 'fadeIn 0.3s ease-in-out forwards'
          }}
        >
          <img
            src={image}
            alt="zoomed logo"
            onClick={handleClick}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              objectFit: 'contain',
              border: '8px solid rgba(255,255,255,0.8)',
              borderRadius: 12,
              background: 'white',
              boxShadow: '0 10px 20px rgba(0,0,0,0.3)',
              transform: 'scale(0.8)',
              animation: 'zoomIn 0.3s ease-in-out forwards'
            }}
          />
        </div>
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes zoomIn { from { transform: scale(0.8) } to { transform: scale(1) } }
      `}</style>
    </>
  );
};